// extracted by mini-css-extract-plugin
export default {"financeHistory":"OoW0p","table":"Vdxnj"};